export function toNormalizedCombo(event: KeyboardEvent): string {
  const parts: string[] = [];
  if (event.ctrlKey || event.metaKey) parts.push("mod");
  if (event.altKey) parts.push("alt");
  if (event.shiftKey) parts.push("shift");
  const key = normalizeKey(event.key);
  parts.push(key);
  return parts.join("+");
}

export function normalizeShortcut(shortcut: string): string {
  return shortcut
    .toLowerCase()
    .replace("cmd", "mod")
    .replace("command", "mod")
    .replace("ctrl", "mod")
    .replace(/\s+/g, "");
}

function normalizeKey(key: string) {
  const k = key.toLowerCase();
  if (k === " ") return "space";
  if (k === "escape") return "esc";
  if (k === "arrowup") return "arrowup";
  if (k === "arrowdown") return "arrowdown";
  if (k === "arrowleft") return "arrowleft";
  if (k === "arrowright") return "arrowright";
  return k;
}
